import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { Container } from '../common/Container';
import { DINOSAUR_ASCII_TINY } from '../../assets/dinosaur-ascii';

const FooterWrapper = styled.footer`
  background-color: ${theme.colors.backgroundSecondary};
  border-top: 1px solid ${theme.colors.borderLight};
  padding: ${theme.spacing['3xl']} 0 ${theme.spacing.xl};
  margin-top: ${theme.spacing['4xl']};
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${theme.spacing['2xl']};

  @media (min-width: ${theme.breakpoints.md}) {
    grid-template-columns: 2fr 1fr 1fr 1fr;
  }
`;

const BrandSection = styled.div`
  h3 {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.sm};
    font-size: ${theme.fontSizes.xl};
    margin-bottom: ${theme.spacing.md};
  }

  p {
    color: ${theme.colors.text.secondary};
    line-height: 1.8;
  }
`;

const FooterSection = styled.div`
  h4 {
    font-size: ${theme.fontSizes.base};
    font-weight: 600;
    margin-bottom: ${theme.spacing.md};
    color: ${theme.colors.text.primary};
  }

  ul {
    list-style: none;
    padding: 0;
  }

  li {
    margin-bottom: ${theme.spacing.sm};
  }

  a {
    color: ${theme.colors.text.secondary};
    font-size: ${theme.fontSizes.sm};
    
    &:hover {
      color: ${theme.colors.primary};
      text-decoration: none;
    }
  }
`;

const Copyright = styled.div`
  margin-top: ${theme.spacing['2xl']};
  padding-top: ${theme.spacing.lg};
  border-top: 1px solid ${theme.colors.borderLight};
  text-align: center;
  color: ${theme.colors.text.muted};
  font-size: ${theme.fontSizes.sm};
`;

export const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      <Container>
        <FooterContent>
          <BrandSection>
            <h3>
              <span>{DINOSAUR_ASCII_TINY}</span>
              Promptasaurus
            </h3>
            <p>
              Make your prompts roar! Enhance your AI interactions with 
              intelligent prompt improvements powered by advanced language models.
            </p>
          </BrandSection>
          
          <FooterSection>
            <h4>Product</h4>
            <ul>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/demo">Demo</Link></li>
              <li><Link to="/extension">Browser Extension</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
            </ul>
          </FooterSection>
          
          <FooterSection>
            <h4>Resources</h4>
            <ul>
              <li><Link to="/docs">Documentation</Link></li>
              <li><Link to="/docs/api">API Reference</Link></li>
              <li><a href="https://github.com/gruntwork/gruntwork-promptasaurus" target="_blank" rel="noopener noreferrer">GitHub</a></li>
              <li><Link to="/blog">Blog</Link></li>
            </ul>
          </FooterSection>
          
          <FooterSection>
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
            </ul>
          </FooterSection>
        </FooterContent>
        
        <Copyright>
          © {new Date().getFullYear()} Promptasaurus by Gruntwork. All rights reserved.
        </Copyright>
      </Container>
    </FooterWrapper>
  );
};